<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { TransactionFormData } from './types';

  const dispatch = createEventDispatcher<{ addTransaction: TransactionFormData }>();
  export let payee: string = '';
  export let payAmount: string = '';
  export let payDate: string = '';
  export let memo: string = 'Confirmation number: ';
  export let billId: number = 0;

  const handleSubmit = (): void => {
    dispatch('addTransaction', { payee, payAmount, payDate, memo, billId });
  };
</script>

<form on:submit|preventDefault={handleSubmit}>
  <label>
    <lblname>Biller</lblname>
    <input type="text" placeholder="biller" bind:value={payee} required>
  </label>
  <label>
    <lblname>Amount</lblname>
    <input type="text" placeholder="amount" bind:value={payAmount} required>
  </label>
  <label>
    <lblname>Due Date</lblname>
    <input type="text" placeholder="due date" bind:value={payDate} required>
  </label>
  <label>
    <lblname>Memo</lblname>
    <input type="text" placeholder="memo" bind:value={memo}><br>
  </label>
  <button class="button-primary">Add transaction</button>
</form>

<style>
  form {
    text-align: left;
  }
  lblname {
    display: block;
    font-weight: bold;
    font-size: 1em;
  }
  input {
    margin-bottom: 1em;
    width: 100%;
  }
  button {
    width: 100%;
  }
</style>